import { render, staticRenderFns } from "./contacto1.vue?vue&type=template&id=4aeca38e"
import script from "./contacto1.vue?vue&type=script&lang=js"
export * from "./contacto1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports